import Marty from "marty";
import assign from "object-assign";
import _ from "lodash";

function base(props, constants) {
    let baseProps = {
            handlers: {
                handleError: []
            },
            handleError(err) {
                console.log("handling error from base:", err);
            }
        },
        errorTest = /\_FAILED$/;

    //Loop through all constants to make sure errors are handled
    _.forOwn(constants, (constant) => {
        //Test constant to see if it is an error event
        if (errorTest.test(constant)) {
            let needsHandler = true;

            //Check and see if this error is already handled through a passed in handler
            _.forOwn(props.handlers, (handler) => {
                if (Array.isArray(handler) && (handler.indexOf(constant) > -1) || handler === constant) {
                    needsHandler = false;
                }
                return needsHandler;
            });
            //Only add in default handler if no other handler was found
            if (needsHandler) {
                baseProps.handlers.handleError.push(constant);
            }
        }
    });

    props.handlers = assign({}, baseProps.handlers, props.handlers);

    return Marty.createStore(assign({}, baseProps, props));
}

export default base;



/** WEBPACK FOOTER **
 ** ./app/utils/stores/base.js
 **/